/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerListCustomersQueryResponse, TransferCustomersControllerListCustomersQueryParams, TransferCustomersControllerListCustomers401, TransferCustomersControllerListCustomers403 } from "../../models/transferCustomersController/TransferCustomersControllerListCustomers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transferCustomersControllerListCustomers } from "../../clients/transfer-customersService/transferCustomersControllerListCustomers";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transferCustomersControllerListCustomersQueryKey = (params: TransferCustomersControllerListCustomersQueryParams = {}) => [{
  url: '/api/v1/transfer-customers'
}, ...(params ? [params] : [])] as const;
export type TransferCustomersControllerListCustomersQueryKey = ReturnType<typeof transferCustomersControllerListCustomersQueryKey>;
export function transferCustomersControllerListCustomersQueryOptions(params?: TransferCustomersControllerListCustomersQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transferCustomersControllerListCustomersQueryKey(params);
  return queryOptions<TransferCustomersControllerListCustomersQueryResponse, ResponseErrorConfig<TransferCustomersControllerListCustomers401 | TransferCustomersControllerListCustomers403>, TransferCustomersControllerListCustomersQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transferCustomersControllerListCustomers(params, config);
    }
  });
}

/**
 * @summary List customers available for transfer from 1.0 database
 * {@link /api/v1/transfer-customers}
 */
export function useTransferCustomersControllerListCustomers<TData = TransferCustomersControllerListCustomersQueryResponse, TQueryData = TransferCustomersControllerListCustomersQueryResponse, TQueryKey extends QueryKey = TransferCustomersControllerListCustomersQueryKey>(params?: TransferCustomersControllerListCustomersQueryParams, options: {
  query?: Partial<QueryObserverOptions<TransferCustomersControllerListCustomersQueryResponse, ResponseErrorConfig<TransferCustomersControllerListCustomers401 | TransferCustomersControllerListCustomers403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transferCustomersControllerListCustomersQueryKey(params);
  const query = useQuery({
    ...transferCustomersControllerListCustomersQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransferCustomersControllerListCustomers401 | TransferCustomersControllerListCustomers403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}